import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import NavigationVariant from './NavigationVariant';
import NavigationControl from './NavigationControl';

const Navigation = props => {
  const { isVariant } = props;

  const {
    spaseekers: {
      layout: {
        header: { menus },
      },
    },
  } = useStaticQuery(graphql`
    query NavigationQuery {
      spaseekers {
        layout {
          header {
            menus {
              text
              url
              locations {
                text
                url
              }
              regions {
                text
                url
              }
              discoverMore {
                text
                url
              }
              hotels {
                text
                url
              }
              categories {
                text
                url
              }
              insiderTopics {
                text
                url
              }
              insiderSections {
                text
                url
              }
              simpleLinks {
                text
                url
              }
              banner {
                message
                linkText
                linkUrl
              }
            }
          }
        }
      }
    }
  `);

  return isVariant ? (
    <NavigationVariant menus={menus} {...props} />
  ) : (
    <NavigationControl menus={menus} {...props} />
  );
};

export default Navigation;
